import React, { useCallback, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../redux/store';
import { EmptyTable } from '../../EmptyTable';
import { Preloader } from '../../../Client/ui/Preloader';
import { Role } from './Role';

import { DirectoryPage } from '../DirectoryPage';
import {
    getRolesSelector,
    getIsLoadingSelector,
    getIdToDeleteSelector,
    getErrorsSelector, getStatusSelector,
} from '../../../../redux/role/selectors';
import { deleteRole, getRoles } from '../../../../redux/role/asyncThunks';

const prioritiesInfo = {
    path: '/bo/directories/roles/create',
    title: 'Роли',
    text: 'роль',
};

const prioritiesHeadings = ['Имя', 'Действия'];

export const Roles: React.FC = () => {
    const dispatch = useAppDispatch();
    const roles = useSelector(getRolesSelector);
    const isLoading = useSelector(getIsLoadingSelector);
    const idToDelete = useSelector(getIdToDeleteSelector);
    const errors = useSelector(getErrorsSelector);
    const status = useSelector(getStatusSelector);

    useLayoutEffect(() => {
        dispatch(getRoles());
    }, []);

    const modalHandler = useCallback(() => {
        dispatch(deleteRole(idToDelete));
    }, [idToDelete]);

    return (
        <DirectoryPage
            headings={prioritiesHeadings}
            info={prioritiesInfo}
            modalHandler={modalHandler}
            errors={errors}
            status={status}
        >
            {isLoading
                ? <Preloader />
                : (
                    <ul>
                        {roles.length > 0
                            ? roles.map((i) => <Role key={i.id} role={i} />)
                            : <EmptyTable />}
                    </ul>
                )}
        </DirectoryPage>

    );
};
